import React from "react";
import { Col, Form, Input, Row } from "antd";
import { Validator } from "@/utils/validator";
import Label from "./Label";

const ExteriorDimensionsInputs = ({ disabledInputs, units = "in" }) => {
  return (
    <Form.Item label={<Label />} required>
      <Row>
        <Col style={{ flex: 1 }}>
          <Form.Item
            name="length"
            style={{ marginBottom: 0 }}
            rules={Validator.exteriorDimensions("Invalid length")}
            validateFirst
          >
            <Input
              style={{
                borderTopLeftRadius: 10,
                borderBottomLeftRadius: 10,
              }}
              placeholder="length"
              suffix={<span style={{ color: "gray" }}>{units}</span>}
              disabled={disabledInputs[0]}
            />
          </Form.Item>
        </Col>
        <Col style={{ flex: 1 }}>
          <Form.Item
            name="width"
            style={{ marginBottom: 0 }}
            rules={Validator.exteriorDimensions("Invalid width")}
            validateFirst
          >
            <Input
              placeholder="width"
              suffix={<span style={{ color: "gray" }}>{units}</span>}
              disabled={disabledInputs[1]}
            />
          </Form.Item>
        </Col>
        <Col style={{ flex: 1 }}>
          <Form.Item
            name="height"
            style={{ marginBottom: 0 }}
            rules={Validator.exteriorDimensions("Invalid height")}
            validateFirst
          >
            <Input
              style={{
                borderTopRightRadius: 10,
                borderBottomRightRadius: 10,
              }}
              placeholder="height"
              suffix={<span style={{ color: "gray" }}>{units}</span>}
              disabled={disabledInputs[2]}
            />
          </Form.Item>
        </Col>
      </Row>
    </Form.Item>
  );
};
export default ExteriorDimensionsInputs;
